import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import './index.css';
import App from './App';
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const baseUrl = import.meta.env.BASE_URL.replace(/\/$/, '');
const backgroundUrl = `${baseUrl}/images/backgrounds/smiling-nurse.png`;
document.documentElement.style.setProperty(
  '--app-background-image',
  `url(${backgroundUrl})`
);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
